module.exports = __webpack_public_path__ + "static/img/22.0f1584b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/22.png
// module id = EpUg
// module chunks = 0